export default __webpack_public_path__ + "static/img3-140c8f21b8ac364cb243e1302335d205.png";